import { render, staticRenderFns } from "./ClientCreateBranchDesktop.vue?vue&type=template&id=8324b730&scoped=true&"
import script from "./ClientCreateBranchDesktop.vue?vue&type=script&lang=js&"
export * from "./ClientCreateBranchDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8324b730",
  null
  
)

export default component.exports